import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { t } from 'i18next';
import { formateNumber } from '../../../../utils/utils';
import { convertToDecimalPlace } from '../../../../utils/inTakeAuditReportUtils';

export const renderHeaderCell = (
  caption: string,
  config?: { enableSubTitle?: boolean; enableSeperator?: boolean }
) => {
  const { enableSubTitle = true, enableSeperator = true } = config ?? {};
  return (
    <div className="header-content">
      <div>
        <Typography
          aria-label={t(caption)}
          className="typo-text label1_size header-title-text"
        >
          {t(caption)}
        </Typography>
        {enableSubTitle ? (
          <Typography
            aria-label={t('reports.intakeAudit.custodianTable.compresseGB')}
            className="header-sub-text"
          >
            {t('reports.intakeAudit.custodianTable.compresseGB')}
          </Typography>
        ) : null}
      </div>
      <span
        className="column-separator"
        style={{ visibility: enableSeperator ? 'visible' : 'hidden' }}
      />
    </div>
  );
};

export const renderTableCellData = (
  value: string | number,
  textStyle = 'body3_size row-cell-text'
) => {
  const data = typeof value === 'number' ? formateNumber(value) : value;
  return <Typography className={`typo-text ${textStyle}`}>{data}</Typography>;
};

const custodianReportTableColumnDef: GridColDef[] = [
  {
    field: 'custodianName',
    sortable: false,
    renderCell: (params) => renderTableCellData(params.value),
    renderHeader: () => {
      return renderHeaderCell('reports.intakeAudit.custodianTable.custodian', {
        enableSubTitle: false,
      });
    },
    flex: 0.26,
    cellClassName: () => 'custodian-name-cell',
    headerClassName: 'table-header-cell',
  },
  {
    field: 'emailCompressed',
    sortable: false,
    renderCell: (params) => renderTableCellData(convertToDecimalPlace(params.value)),
    renderHeader: () =>
      renderHeaderCell('reports.intakeAudit.custodianTable.email'),
    flex: 0.185,
    cellClassName: () => 'table-data-cell',
    headerClassName: 'table-header-cell',
  },
  {
    field: 'externallyProcessed',
    sortable: false,
    renderCell: (params) => renderTableCellData(convertToDecimalPlace(params.value)),
    renderHeader: () =>
      renderHeaderCell(
        'reports.intakeAudit.custodianTable.externallyProcessed'
      ),
    flex: 0.185,
    cellClassName: () => 'table-data-cell',
    headerClassName: 'table-header-cell',
  },
  {
    field: 'otherData',
    sortable: false,
    renderCell: (params) => renderTableCellData(convertToDecimalPlace(params.value)),
    renderHeader: () =>
      renderHeaderCell('reports.intakeAudit.custodianTable.otherData'),
    flex: 0.185,
    cellClassName: () => 'table-data-cell',
    headerClassName: 'table-header-cell',
  },
  {
    field: 'subTotal',
    sortable: false,
    renderCell: (params) => renderTableCellData(convertToDecimalPlace(params.value)),
    renderHeader: () =>
      renderHeaderCell('reports.intakeAudit.custodianTable.subTotal', {
        enableSeperator: false,
        enableSubTitle: true,
      }),
    flex: 0.185,
    cellClassName: () => 'table-data-cell',
    headerClassName: 'table-header-cell',
  },
];

export default custodianReportTableColumnDef;
